import { writable } from "svelte/store";

let stored_section = localStorage.getItem("section");

if (!stored_section) {
    localStorage.setItem("section", "dashboard");
    stored_section = localStorage.getItem("section");
}

export const section = writable(stored_section);

section.subscribe(value => {
    console.log(value)
    localStorage.setItem("section", value ? value : 'dashboard');
});